
const getObjectList = require('./getObjectList').default;

export const REQUEST_GET_ODRUDA_LIST = 'odrudaList/REQUEST_GET_ODRUDA_LIST';
export const RESPONSE_GET_ODRUDA_LIST = 'odrudaList/RESPONSE_GET_ODRUDA_LIST';
export const SET_FILTER = 'odrudaList/SET_FILTER';

export const getOdrudaList = () => {
    return (dispatch, getState) => {
        getObjectList({
            objectList: getState().odrudaList,
            requestFunc: requestGetOdrudaList,
            responseFunc: responseGetOdrudaList,
            url: '/api/odruda/',
            dispatch
        });
    };
};

export const setFilter = (id, value) => {
    return {
        type: SET_FILTER,
        attributeId: id,
        attributeValue: value
    };
}

const requestGetOdrudaList = () => ({
    type: REQUEST_GET_ODRUDA_LIST
});

const responseGetOdrudaList = (res) => ({
    type: RESPONSE_GET_ODRUDA_LIST,
    error: res.error,
    data: res.data
});
